import { Vue, Component, Watch} from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { ResearchModel } from '@/models/research/research';
import { sortByProperty } from '@/utils/utils';
import ResearchPullOut from './research-pull-out/research-pull-out';

@Component({
    name: 'research',
    components: {
        'material-icon': GoogleMaterialIcon,
        'research-pull-out': ResearchPullOut,
    },
})

export default class Research extends Vue {

    // ------------------------------------------------------
    // Properties

    private contentList: ResearchModel[] = [];

    private isTeamList: boolean = false;

    private activeIndex: number = -1;

    private sortOptions: any = [];

    private selectedProject: ResearchModel = {};

    /**
     * Hold the list of research projects
     */
    private get researchProjects() {
        return this.$store.state.researchStore.researchProjects;
    }

    @Watch('researchProjects')
    private onChangeList(value: ResearchModel[]) {
        this.contentList = value;
    }

    /**
     * Hold the list list of Categories
     */
    private get researchCategories() {
        return this.$store.getters['researchStore/categoryList'];
    }

    /**
     * Hold the list of teams
     */
    private get reasearchTeams() {
        return this.$store.getters['researchStore/teamList'];
    }



    // ------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.$store.dispatch('researchStore/fetchResearchProjects');
    }

    // -------------------------------------------------------------------------------------
    // Actions

    /**
     * Action trigger when click on category from research category
     * @param name
     */
    private onSelectCategory(name: string) {
        this.isTeamList = false;
        this.activeIndex = this.researchCategories.indexOf(name);
        this.contentList =  name === 'all' ? this.researchProjects : this.categoriesTypes(name);
    }

    /**
     * Action trigger when click on team from research teams
     * @param name
     */
    private onSelectTeam(name: string) {
        this.isTeamList = true;
        this.activeIndex = this.reasearchTeams.indexOf(name);
        this.contentList =  name === 'all' ? this.researchProjects : this.teamsTypes(name);
    }

    /**
     * Action trigger when click on content in project list
     * @param content
     */
    private selectProject(content: ResearchModel) {
        this.selectedProject = content;
        (this.$el.querySelector('.research-pull-out-container') as HTMLElement).style.left = '24%';
    }
    // --------------------------------------------------------------------------------------
    // Methods

    /**
     * Method help to get categories count based on category name
     * @param name
     */
    private categoriesTypes(name: string) {
        return this.researchProjects.filter(
            (item: ResearchModel) => item.category === name) || [];
    }

    /**
     * Method help to get teams count based on team name
     * @param name
     */
    private teamsTypes(name: string) {
        return this.researchProjects.filter(
            (item: ResearchModel) => item.teams && item.teams.find((team: any) => team.name === name)) || [];
    }

    private sortTable(itemName: any) {
        this.sortOptions = this.sortOptions.indexOf(itemName) !== -1
                ? this.sortOptions.filter((items: any) => items !== itemName)
                : this.sortOptions.concat([itemName]);
        const sortOrder = this.sortOptions.indexOf(itemName) !== -1 ? 'ASC' : 'DESC';
        if (itemName === 'teams') {
            this.contentList = this.contentList.sort((a: any, b: any) => {
                 if (a.teams === null || !a.teams.length) {
                    return 1;
                } else if (b.teams === null || !b.teams.length) {
                    return -1;
                } else if (a.teams[0].name === b.teams[0].name) {
                    return 0;
                } else {
                    return a.teams[0].name < b.teams[0].name ? 1 : -1;
                }
        });
            if (sortOrder === 'DESC') {
             this.contentList = this.contentList.reverse();
        }
            return;
      }
        sortByProperty(this.contentList, itemName, sortOrder);
    }

}
